import { useDispatch, useSelector } from "react-redux";

import { selectorSystemOnLine } from "../store/system/selectors";
import { _sharedActionsSystem } from "../store/system/actions";

const useOnlineOnlyHandler = () => {
  const dispatch = useDispatch();
  const onLine = useSelector(selectorSystemOnLine);

  return (cb, cbOffline) => (...args) => {
    if (onLine) {
      cb(...args);
    } else {
      if (cbOffline) {
        cbOffline(...args);
      }

      dispatch(_sharedActionsSystem.toast(
        ["@sw:noInternetConnection", ". ", "@sw:featureNotAvailable", "."]
      ));
    }
  };
};

export default useOnlineOnlyHandler;
